import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, input } from '@angular/core';

import { Icon } from '../../icon';
import { IconComponent } from '../../icon/icon.component';

@Component({
  selector: 'button[smw-fab], a[smw-fab]',
  imports: [IconComponent],
  templateUrl: './fab.component.html',
  styleUrls: ['./fab.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FABComponent {
  constructor(private elementRef: ElementRef<HTMLElement>) {}

  /** @default Icon.add */
  icon = input<Icon>(Icon.add);
  /** @default false */
  disabled = input<boolean>(false);

  @HostBinding('attr.type') get typeAttribute(): string | null {
    if (this.elementRef.nativeElement.tagName === 'button') {
      return 'button';
    }

    return null;
  }

  @HostBinding('attr.disabled') get disableState(): boolean | null {
    return this.disabled() || null;
  }
}
